'use client';

import { c as _c } from "react/compiler-runtime";
import type { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import type React from 'react';
import { styled } from '@mui/material/styles';
type TooltipProps = MuiTooltipProps;
const StyledTooltip = styled(({
  className,
  ...props
}: TooltipProps) => <Tooltip {...props} arrow classes={{
  popper: className
}} />)(({
  theme
}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    // display: 'flex',
    // padding: theme.sizes.spacing['06'],
    // flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'center',
    // gap: theme.sizes.spacing['02'],
    // alignSelf: 'stretch',
    background: 'rgba(19, 18, 16, 0.80)',
    // fontFamily: theme.fonts.family.body,
    // fontStyle: 'normal',
    // fontWeight: theme.fonts.weight.normal,
    color: theme.colors.text.inverted,
    // fontSize: theme.fonts.size.xs,
    borderRadius: theme.sizes.radius.md,
    boxShadow: '0px 12px 16px - 4px rgba(36, 5, 5, 0.12), 0px 4px 6px - 2px rgba(36, 5, 5, 0.06)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'rgba(19, 18, 16, 0.80)'
  }
}));
const TooltipComponent: React.FC<TooltipProps> = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = {
      tooltip: {
        className
      }
    };
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <StyledTooltip {...props} slotProps={t1}>{children}</StyledTooltip>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default TooltipComponent;
export type { TooltipProps };